import {
  Chat as ChatIcon,
  Forum as ForumIcon,
  Group as GroupIcon,
  Home as HomeIcon,
  Notifications as NotificationsIcon,
} from '@mui/icons-material';
import { Badge, Box, useMediaQuery, useTheme } from '@mui/material';
import { RightMenuNavigation } from 'app/enums';
import { AppCountersContext, RightSidebarContext } from 'app/providers';
import classNames from 'classnames';
import { ChatSessionContext } from 'modules/chat/providers';
import React, { FC, ReactElement, useCallback, useContext, useMemo } from 'react';
import { useStyles } from './RightSidebarNavigation.styles';

interface NavigationItem {
  label: RightMenuNavigation;
  badge: number;
  icon: ReactElement;
}

export const RightSidebarNavigation: FC = () => {
  const theme = useTheme();
  const { classes } = useStyles();

  const { activeTab, setActiveTab } = useContext(RightSidebarContext);
  const { unreadNotificationsCount } = useContext(AppCountersContext);
  const { unreadConversationsCount } = useContext(ChatSessionContext);
  const isFullScreen = useMediaQuery(theme.breakpoints.up('lg'), { noSsr: true });

  const onChangeHandler = useCallback(
    (value: RightMenuNavigation) => setActiveTab(value),
    [setActiveTab]
  );

  const navigationItems = useMemo<NavigationItem[]>(() => {
    const baseNavigations = [
      {
        label: RightMenuNavigation.Notification,
        badge: unreadNotificationsCount,
        icon: <NotificationsIcon />,
      },
      { label: RightMenuNavigation.GlobalChat, badge: 0, icon: <ForumIcon /> },
      { label: RightMenuNavigation.Messages, badge: unreadConversationsCount, icon: <ChatIcon /> },
      { label: RightMenuNavigation.Players, badge: 0, icon: <GroupIcon /> },
    ];
    const mobileNavigation = [
      { label: RightMenuNavigation.Home, badge: 0, icon: <HomeIcon /> },
      ...baseNavigations,
    ];

    return isFullScreen ? baseNavigations : mobileNavigation;
  }, [isFullScreen, unreadConversationsCount, unreadNotificationsCount]);

  return (
    <Box className={classes.root}>
      {navigationItems.map((navigation) => {
        return (
          <Box
            key={navigation.label}
            className={classNames(classes.navigationItem, {
              active: activeTab === navigation.label,
            })}
            onClick={() => onChangeHandler(navigation.label)}
          >
            <Badge badgeContent={navigation.badge} color="primary">
              {navigation.icon}
            </Badge>
          </Box>
        );
      })}
    </Box>
  );
};
